import React, {forwardRef} from 'react';

interface popupProps {
  modalRef?: any;
}

const SN_SAL_SAO_REG_001_POP_002 = forwardRef(({modalRef}: popupProps, ref)=> {
  return (
    <div>
      SN_SAL_SAO_REG_001_POP_002 프로젝트 도움창
    </div>
  );
});

export default SN_SAL_SAO_REG_001_POP_002;